<template>    
    <mainlist
        color="#fff"
        :items="projects"
        :list="list"
    ></mainlist>
</template>
<script>
    import { mapGetters } from 'vuex';    
    import mainlist from '../components/lists/MainList.vue';     
    export default {   
    
    props: [
        
    ],
    components:{
        mainlist: mainlist
    },
    data() {
        return {  
           list:"projects"
                    
        }
    },
    computed: {
        ...mapGetters({            
            projects: 'projects/projects'
        }),
        
    },
    methods: {
        
    },
    mounted() {
        this.$store.dispatch('projects/getAll')
    }
    
    
}
</script>